import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MembershipBreakdownTable from "./smartComponents/membershipBreakdownTable";
import MembershipBreakdownPieChart from "./smartComponents/membershipBreakdownPieChart";
import SingleDatePicker from "./smartComponents/singleDatePicker";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { actionCreators } from "./redux/sagas/membershipBreakdown/membershipBreakdown";
import styles from "./membershipBreakdown.module.css";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import MembershipBreakdownLearnMore from "./smartComponents/membershipBreakdownLearnMore";

export class MembershipBreakdownModule extends React.Component {
  componentDidMount() {
    this.props.fetchCurrentUser(this.props.queryParams);
    document.addEventListener("refreshDate", (e) =>
      this.props.fetchCurrentUser(e.date, this.props.queryParams)
    );
  }

  componentDidUpdate() {
    const firstColumnInMBTable = $("#membershipBreakdown .ht_master tbody tr td:first-child");
    $.each(firstColumnInMBTable, function () {
      const cell = $(this)[0];
      $(cell).attr("title", $(this)[0].innerHTML);
    });
  }

  getContent() {
    return (
      <>
        {this.props.data.length > 0 ? (
          <div className={styles.membershipBreakdown} id="membershipBreakdownModule">
            <div className={`dropdown dropdown-actions ${styles.actions}`}>
              <div className={styles.togglers}>
                {this.props.queryParams.params.displayGroupByRevenueCategoryToggle && (
                  <a
                    className={`${styles.toggle} ${
                      this.props.groupByRevenueCategory ? styles.active : ""
                    }`}
                    onClick={this.props.updateGroupByRevenueCategory}
                  >
                    Group Memberships By Revenue Category
                  </a>
                )}

                {this.props.queryParams.params.displayIncludeZeroRevenueSalesToggle && (
                  <a
                    className={`${styles.toggle} ${
                      this.props.includeZeroSales ? styles.active : ""
                    }`}
                    onClick={this.props.updateIncludeZeroSales}
                    style={{ marginLeft: "10px" }}
                  >
                    Include $0 Sales
                  </a>
                )}
              </div>
              <SingleDatePicker />
            </div>

            {this.props.tableLoading ? (
              <LoadingAnimation />
            ) : (
              <React.Fragment>
                <MembershipBreakdownTable />
                <div className={styles.pieChart}>
                  <MembershipBreakdownPieChart />
                </div>
              </React.Fragment>
            )}
          </div>
        ) : (
          <p
            style={{
              textAlign: "center",
              fontSize: "35px",
              color: "#86919F",
              height: "400px",
              lineHeight: "400px"
            }}
          >
            No data available for today.
          </p>
        )}
      </>
    );
  }

  render() {
    return (
      <SectionToggle
        isLoading={this.props.isLoading}
        title="Membership Breakdown"
        content={this.getContent()}
        learnMore={
          <MembershipBreakdownLearnMore
            sourceType={this.props.sourceType}
            organizationName={this.props.params?.organization_name}
          />
        }
      />
    );
  }
}

export default connect(
  (state) => ({
    groupByRevenueCategory: state.membershipBreakdown.groupByRevenueCategory,
    includeZeroSales: state.membershipBreakdown.includeZeroSales,
    isLoading: state.membershipBreakdown.isLoading,
    data: state.membershipBreakdown.membershipsInfo.data || [],
    tableLoading: state.membershipBreakdown.tableLoading,
    sourceType: state.membershipBreakdown.currentUser.params.sourceType
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    updateGroupByRevenueCategory: actionCreators.updateGroupByRevenueCategory,
    updateIncludeZeroSales: actionCreators.updateIncludeZeroSales
  }
)(MembershipBreakdownModule);

MembershipBreakdownModule.propTypes = {
  groupByRevenueCategory: PropTypes.bool.isRequired,
  includeZeroSales: PropTypes.bool.isRequired,
  fetchCurrentUser: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  queryParams: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  tableLoading: PropTypes.bool.isRequired,
  updateGroupByRevenueCategory: PropTypes.func.isRequired,
  updateIncludeZeroSales: PropTypes.func.isRequired,
  source: PropTypes.string
};
